import React from 'react';
import GlobalStyle from '../assets/global.style';
import SimpleHeader from '../components/SimpleHeader-comp/simpleheader';
import DoNotSellContent from '../components/DoNotSellContent-comp/donotsellcontent';
import Footer from '../components/Footer-comp/footer';


function DoNotSell() {
  return (

      <div className="App">
        <GlobalStyle/>
        <SimpleHeader/>
        <DoNotSellContent/>
        <Footer/>
      </div>
    
  );
}

export default DoNotSell